import { render, staticRenderFns } from "./FeedSettings.vue?vue&type=template&id=8667713c&"
import script from "./FeedSettings.vue?vue&type=script&lang=js&"
export * from "./FeedSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports